<template>
	<div>
		<OfferingsIpoArcOfFinancialHistory />

		<OfferingsIpoHistoryOfMarkets />

		<OfferingsIpoWhoWeAre />

		<OfferingsIpoInvestorGrowth />

		<OfferingsIpoHistoricalSharePrices />

		<OfferingsIpoFaq />
	</div>
</template>

<script setup lang="ts">
import { appCloudfrontPath } from '@constants';
import OfferingsIpoArcOfFinancialHistory from '@components/offerings/ipo/offerings-ipo-arc-of-financial-history.vue';
import OfferingsIpoFaq from '@components/offerings/ipo/offerings-ipo-faq.vue';
import OfferingsIpoHistoricalSharePrices from '@components/offerings/ipo/offerings-ipo-historical-share-prices.vue';
import OfferingsIpoHistoryOfMarkets from '@components/offerings/ipo/offerings-ipo-history-of-markets.vue';
import OfferingsIpoInvestorGrowth from '@components/offerings/ipo/offerings-ipo-investor-growth.vue';
import OfferingsIpoWhoWeAre from '@components/offerings/ipo/offerings-ipo-who-we-are.vue';
import { useHead } from '@unhead/vue';

const metaTitle = 'Fundrise iPO | Investments';
const metaDescription = 'The Fundrise iPO - Become an investor in the company and a partner in our future.';

function setup(): void {
	useHead({
		title: metaTitle,
		meta: [
			{ property: 'og:title', content: metaTitle },
			{ name: 'description', content: metaDescription },
			{ property: 'og:description', content: metaDescription },
			{
				property: 'og:image',
				content: `${appCloudfrontPath}/images/fcx/ipo-opengraph.jpg`
			}
		]
	});
}

setup();
</script>
